import { motion } from 'framer-motion'
import styled from 'styled-components'
import nojaRahoitusImgSrc from '@assets/noja/noja-logo.png'
import { Button } from '@root/components'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLocalStorage } from '@root/hooks'
import { useBusinessContext } from '@root/context'
import { FaTimes } from 'react-icons/fa'

const NOJA_ROYAL_BLUE = '#053773'
const NOJA_YELLOW = '#e5cd36'

type DismissValue = 'dismissed' | undefined

const NojaAd: React.FC = () => {
  const { slug } = useBusinessContext()
  const { t } = useTranslation()

  const [isDismissed, setDismissed] = useLocalStorage<DismissValue>(`${slug}.nojaAd`, undefined)

  return (
    isDismissed !== 'dismissed' && (
      <StyledContainer>
        <StyledLeftContainer>
          <StyledImg src={nojaRahoitusImgSrc} />
        </StyledLeftContainer>
        <StyledRightContainer>
          <StyledHeader>{t('invoicing.nojaAd.title')}</StyledHeader>
          <StyledLink to={'noja'}>
            <StyledNojaButton>{t('invoicing.nojaAd.button')}</StyledNojaButton>
          </StyledLink>
        </StyledRightContainer>
        <DismissButton onClick={() => setDismissed('dismissed')}>
          <FaTimes />
        </DismissButton>
      </StyledContainer>
    )
  )
}

export default NojaAd

const StyledLink = styled(Link)`
  display: inline-block;
  width: fit-content;
  height: fit-content;
`

const StyledNojaButton = styled(Button)`
  background: ${NOJA_YELLOW} !important;
  color: ${NOJA_ROYAL_BLUE} !important;
`

const StyledHeader = styled.h4`
  color: ${NOJA_ROYAL_BLUE};
  margin-bottom: ${({ theme }) => theme.spacing.sm}rem;
`

const StyledImg = styled.img`
  height: 18px;
`

const StyledRightContainer = styled.div`
  padding-top: 0;
  padding-bottom: ${({ theme }) => theme.spacing.md}rem;
  padding-right: ${({ theme }) => theme.spacing.xl}rem;
  padding-left: ${({ theme }) => theme.spacing.md}rem;

  flex: 1;
  overflow: auto;
`

const StyledLeftContainer = styled.div`
  padding: 18px;
  display: flex;

  'align-items: flex-start;' 
  'justify-content: flex-start;' 
`

const StyledContainer = styled(motion.div).attrs({
  initial: { opacity: 0 },
  animate: { opacity: 1 }
})`
  display: flex;
  flex-wrap: wrap;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  color: ${({ theme }) => theme.colors.neutralBlack};
  background: ${({ theme }) => theme.colors.neutralWhite};

  border: 2px solid ${NOJA_ROYAL_BLUE};

  flex-direction: column;

  position: relative;
  overflow: auto;
`
const DismissButton = styled.button`
  position: absolute;
  top: ${({ theme }) => theme.spacing.sm}rem;
  right: ${({ theme }) => theme.spacing.sm}rem;
  color: ${({ theme }) => theme.colors.iconGrayDark};
  outline: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
`
